import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Loader from '@amzn/meridian/loader';
import { BatchPublishProgressBarProps } from './types';

const BatchPublishProgressBar: React.FC<BatchPublishProgressBarProps> = ({ total, completed, failed, inProgress }) => {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <Column spacing="200" width="100%">
      {inProgress ? (
        <>
          <Row alignmentHorizontal="justify">
            <Text type="b200">
              Publishing {completed + 1} of {total}...
            </Text>
            <Text type="b200">{percentage}%</Text>
          </Row>
          <Loader type="linear" size="large" />
        </>
      ) : (
        <Row spacing="300" alignmentVertical="center">
          <Text type="b200">
            {completed - failed} succeeded, {failed} failed
          </Text>
          <div
            style={{
              height: 6,
              flex: 1,
              borderRadius: 3,
              backgroundColor: '#e0e0e0',
              overflow: 'hidden',
            }}
            role="progressbar"
            aria-valuenow={percentage}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div
              style={{
                height: '100%',
                width: `${percentage}%`,
                backgroundColor: failed > 0 ? '#d13212' : '#1d8102',
                borderRadius: 3,
              }}
            />
          </div>
        </Row>
      )}
    </Column>
  );
};

export default BatchPublishProgressBar;
